import * as React from 'react';
import {FC, JSX} from "react";
import EpidStatusTable from "./view/EpidStatusTable.tsx";
import Profile from "../../Model/Profile.ts";


export interface EpidStatusProps {
    token: string;
    profile: Profile;
}

export const EpidStatus: FC<EpidStatusProps> = (props): JSX.Element => {
    console.log(props);
    return (
        <EpidStatusTable {...props}/>
    );
};

export default EpidStatus;

